'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndMarx } from '../../Entities/Ind/IndMarx';
import { IndMarxCollection } from '../../Collections/Ind/IndMarxCollection';

export class IndMarxRepository extends CoreRepository {
  public getIndMarxs(options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getIndMarxs(options).then((response) => {
      const collection = new IndMarxCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new IndMarx();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  /*
    public getIndMarx(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getIndMarx(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let IndMarx = new IndMarx();
            IndMarx.hydrate(response);

            return IndMarx;
        });
    }

    public createIndMarx(payload: object = {}){  
    return this.webAPI.createIndMarx(payload)
      .then( response => {
        let IndMarx = new IndMarx();
        IndMarx.hydrate(response);

        return IndMarx;
      });
    }
    */
  public updateIndMarx(id, payload: object = {}) {
    return this.webAPI.updateIndMarx(id, payload).then((response) => {
      const individualMarx = new IndMarx();
      individualMarx.hydrate(response);

      return IndMarx;
    });
  }
  /*
    public removeIndMarx( ){
        return this.webAPI.removeIndMarx()
        .then( response => {
            return response;
        });
    }
    */
}
